import { render, staticRenderFns } from "./index-原料区道闸.vue?vue&type=template&id=1ed45f72&scoped=true&"
import script from "./index-原料区道闸.vue?vue&type=script&lang=js&"
export * from "./index-原料区道闸.vue?vue&type=script&lang=js&"
import style0 from "./index-原料区道闸.vue?vue&type=style&index=0&id=1ed45f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed45f72",
  null
  
)

export default component.exports